import { Point, PrintArea, Size } from '@/types';
import { clamp } from '@/utils/math/clamp';
import { getPrintAreaSize } from '@/model/printArea/getPrintAreaSize';

const getOffsetDirection = (
  offset: number,
  currentSize: number,
  nextSize: number,
  space: number
) => {
  const nextOffset = offset + (currentSize - nextSize) / 2;
  const diff = space - nextSize - 1;
  // if the size fits inside the space make sure that it is positioned inside
  return diff > 0 ? clamp(nextOffset, diff) : nextOffset;
};

export const getOffsetAfterResize = (
  offset: Point,
  currentSize: Size,
  nextSize: Size,
  printArea: PrintArea
): Point => {
  const printAreaSize = getPrintAreaSize(printArea);
  return {
    x: getOffsetDirection(offset.x, currentSize.width, nextSize.width, printAreaSize.width),
    y: getOffsetDirection(offset.y, currentSize.height, nextSize.height, printAreaSize.height),
  };
};
